//Module for session-connection
import UAParser from 'ua-parser-js'
import * as Cookies from 'tiny-cookie'
import feathersClient from '@/api/feathers-client'
import logger from '@/api/logger'
import eventLog from '@/api/eventLog'
import axios from 'axios';
import $config from '@/config'

let isStopped = true;

export default {
  actions: {
    track(context, params) {
      return new Promise((resolve, reject) => {
        let registration = context.rootGetters['registrations/getCopy'];
        let webcast = context.rootGetters['webcast/getCopy'];
        let device = context.rootGetters['devices/getCopy'];
        let connection = context.rootGetters['session-connections/getCopy'];
        let stream = context.rootGetters['stream/getCopy'];
        let payload = {};
        let self = this;

        let createSessionConnection = function () {
          payload = {
            webcastId: webcast._id,
            streamId: stream,
            sessionId: webcast.currentSessionId,
            deviceId: device._id,
            device: device,
            watchStarted: new Date(),
            isWatching: false
          }

          if (registration) {
            payload['reg'] = registration
            payload['regId'] = registration._id
          }

          eventLog('createSessionConnection', context, payload);
          return self.dispatch('session-connections/create', payload).then((conn) => {
            console.log("connection created");
            context.commit("setCurrent", conn);
            connection = conn;
            feathersClient['subscribe'] = {
              connection: conn._id,
              webcastId: webcast._id
            }

            feathersClient.io.emit('subscribe', {
              connection: conn._id,
              webcastId: webcast._id
            });
          });

        }

        switch (params.eventName) {
          case 'ready':
            createSessionConnection().then(() => {
              resolve(context);
            })
            eventLog('ready', context, {});
            break;

          case 'metrics':
            const metric_data = {
              webcastId: webcast._id,
              counters: params.data.counters,
              timers: params.data.timers,
              isWatching: params.data.isWatching
            }
            eventLog('metrics', context, metric_data);
            if (!connection) {
              createSessionConnection().then(() => {
                axios.patch($config.feathersServer + '/session-connections/' + connection._id, metric_data).then(() => {
                  resolve(context);
                });
              });
            } else {
              axios.patch($config.feathersServer + '/session-connections/' + connection._id, metric_data).then(() => {
                resolve(context);
              });
            }

            break;

          case 'play':

            const play_data = {
              webcastId: webcast._id,
              isWatching: true
            }
            eventLog('play', context, play_data);
            if (!connection) {
              createSessionConnection().then(() => {
                axios.patch($config.feathersServer + '/session-connections/' + connection._id, play_data).then(() => {
                  resolve(context);
                });
              });
            } else {
              axios.patch($config.feathersServer + '/session-connections/' + connection._id, play_data).then(() => {
                resolve(context);
              });
            }

            isStopped = false;
            break;

          case 'pause':
            const pause_data = {
              webcastId: webcast._id,
              isWatching: false
            }
            eventLog('pause', context, pause_data);
            this.dispatch('session-connections/patch', [connection._id, pause_data]).then((connection) => {
              resolve(context);
            });
            break;

          case 'stop':
            isStopped = true;
            const stop_data = {
              webcastId: webcast._id,
              isWatching: false
            }
            eventLog('stop', context, stop_data);
            this.dispatch('session-connections/patch', [connection._id, stop_data]).then((connection) => {
              resolve(context);
            });
            break;
        }
      });
    }
  }
}